import { computed } from 'vue';
import { useDisplay } from 'vuetify';

export function useIsMobile() {
  const { name } = useDisplay();
  return computed(
    () => name.value === 'xs' || name.value === 'sm' || name.value === 'md'
  );
}
